module.exports = __webpack_public_path__ + "static/media/vote.03e7fa69.svg";